import {ApolloClient} from "@apollo/client";
import gql from "graphql-tag";

import {ActorTypes} from "../../rfxportal/pages/RFXRequest/steps/RFXRequestSuppliersStep/types";

export const isActionAllowedQuery = gql`
  query isActionAllowed($input: TS_IsActionAllowedRequest!) {
    isActionAllowed(input: $input)
  }
`;

export interface IsActionAllowedParams {
    client: ApolloClient<object>;
    permissions: String[];
    user: string;
}

export interface IsActionAllowedResult {
    isActionAllowed: boolean;
}

export async function checkIsActionAllowed({client, permissions, user}: IsActionAllowedParams):
        Promise<IsActionAllowedResult> {
    const variables = {
        input: {
            mlacActions: permissions,
            principal: {type: ActorTypes.USER, id: user},
        }
    };

    const response = await client.query({
        query: isActionAllowedQuery,
        variables
    });
    return response.data.isActionAllowed;
}